import { useEffect, useState } from 'react';
import { supabase } from './supabase';

export function useAccentColor() {
  const [accentColor, setAccentColor] = useState('#3B82F6');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Set default accent color immediately to prevent flash
    document.documentElement.style.setProperty('--accent-color', '#3B82F6');
    document.documentElement.style.setProperty('--accent-color-hover', adjustColor('#3B82F6', -10));
    
    setLoading(false);
  }, []);

  // Helper function to darken/lighten color for hover states
  const adjustColor = (hex: string, percent: number) => {
    const num = parseInt(hex.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = (num >> 8 & 0x00FF) + amt;
    const B = (num & 0x0000FF) + amt;
    return '#' + (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    ).toString(16).slice(1);
  };

  return { accentColor, loading };
}